<!--行业选择器-->
<template>
  <div class="industry-picker">
    <input
      type="text"
      class="base-input"
      placeholder="请选择"
      readonly="readonly"
      @click="openPicker"
      v-bind:value="text"
      v-on:input="$emit('input', $event.target.value)"
    />

    <transition name="fade">
      <div class="picker-bg" v-if="showPicker">
        <div class="picker">
          <div class="picker-title">
            <h3>
              选择行业
              <span @click="closePicker" title="关闭">&times;</span>
            </h3>
          </div>
          <!--已选项-->
          <div class="picker-selected">
            <ul class="selected-list cf">
              <li v-for="(item,index) in industrySelected" :key="item.name">
                <div class="selected-item">
                  <span :title="item.name">{{item.name}}</span>
                  <i
                    class="icon-close"
                    title="取消选择"
                    @click="cancelSelectIndustryItem(index)"
                  >&times;</i>
                </div>
              </li>
              <li>
                <p class="tips">
                  最多可选
                  <strong>{{maxcount||1}}</strong>个行业
                </p>
              </li>
            </ul>
          </div>

          <!--行业选项列表-->

          <div class="picker-body cf">
            <el-scrollbar style="height: 392px;overflow-x: hidden;">
              <div
                class="options"
                v-for="(item,index) in industryArray"
                :key="item.id"
                @click="pickIndustryItem(index)"
                v-cloak
              >
                <input type="checkbox" name="picker-item" />
                <div class="fake-checker">
                  <span class="circle-hollow" v-if="!item.checked"></span>
                  <img src="../../assets/img/common/icon-circle-tick.png" v-if="item.checked" />
                </div>
                <span class="options-text" :title="item.name">{{item.name}}</span>
              </div>
            </el-scrollbar>
          </div>

          <!--错误提示-->
          <transition name="fade">
            <div class="picker-tips" v-if="showError">
              <p v-text="errorText"></p>
            </div>
          </transition>

          <!--操作-->
          <div class="picker-footer cf">
            <a href="javascript:;" class="btn-operation btn-cancel" @click="closePicker">取消</a>
            <a href="javascript:;" class="btn-operation btn-finish" @click="finishPick">确定</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
//@parma maxcount	Number  说明：最多可选择的数量
import { httpGetIndustryJson } from "@/api/common";

export default {
  name: "IndustryPicker",
  props: {
    maxcount: {
      type: Number,
      required: false
    },
    value: {
      type: Array
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      showPicker: false,
      industryArray: [],
      industrySelected: [],
      industrySelectedText: "",
      temp_industrySelected: [], //临时的备份，当用户进来选择或删除了项目之后但是没有点击确定，不保存他的操作
      showError: false,
      errorText: ""
    };
  },
  methods: {
    //打开选择器->根据行业列表数据是否为空判断该执行的操作(判断初次打开或是传入选项)
    openPicker() {
      if (this.value.length <= 0) {
        this.industrySelected = [];
        this.temp_industrySelected = [];
      }
      this.PickerGetOptions();
      //   this.industryArray.length == 0
      //     ? this.PickerGetOptions()
      //     : this.checkSelectedItem();
      this.showPicker = true;
    },

    //检查是否有已选并让候选列表呈现已选状态
    checkSelectedItem() {
      if (this.value.length <= 0) return;

      this.industrySelected = JSON.parse(JSON.stringify(this.value));
      this.temp_industrySelected = JSON.parse(JSON.stringify(this.value)); //缓存一份数据

      //遍历选中列表给候选列表加上相应的状态,通过遍历行业id来匹配
      this.industrySelected.forEach(item => {
        const industryId = item.id;
        this.industryArray.forEach(subItem => {
          if (subItem.id == industryId) {
            subItem.checked = true;
          }
        });
      });
    },

    //关闭选择器-取消或者点关闭按钮，不会保存用户对已选项的操作
    closePicker() {
      this.industryArray.forEach(item => {
        item.checked = false;
      });

      this.industrySelected = JSON.parse(
        JSON.stringify(this.temp_industrySelected)
      );
      this.showPicker = false;
    },

    //选择行业项目
    pickIndustryItem(index) {
      if (
        this.industrySelected.length >= this.maxcount &&
        !this.industryArray[index].checked
      ) {
        this.showError = true;
        this.errorText = "您最多可选择" + this.maxcount + "项";
        return;
      }

      //如果已经是选中的则取消
      if (this.industryArray[index].checked) {
        const selectedItemId = this.industryArray[index].id;
        this.industrySelected.forEach((item, index) => {
          if (item.id == selectedItemId) {
            this.industrySelected.splice(index, 1);
          }
        });
        this.industryArray[index].checked = false;
      } else {
        this.industryArray[index].checked = true;
        let tempObj = {};
        //tempObj.idx = index; //数据在大数组中的位置标记
        tempObj.id = this.industryArray[index].id;
        tempObj.name = this.industryArray[index].name;
        this.industrySelected.push(tempObj);
      }
    },

    //取消已选行业项目-根据唯一的id判断
    cancelSelectIndustryItem(index) {
      const selectedItemId = this.industrySelected[index].id;
      this.industryArray.forEach(item => {
        if (item.id == selectedItemId) {
          item.checked = false;
        }
      });
      this.industrySelected.splice(index, 1);
    },

    //确定选择---存储数据
    finishPick() {
      if (this.maxcount == 1) {
        this.industrySelectedText =
          this.industrySelected.length > 0 ? this.industrySelected[0].name : "";
        this.$emit("finish-industry-pick", this.industrySelected);
      } else {
        this.industrySelectedText = "";
        let temp_str = "";
        this.industrySelected.forEach(item => {
          temp_str += item.name + "，";
        });
        var len = Number(temp_str.length - 1);
        this.industrySelectedText = temp_str.substr(0, len);
        this.$emit("finish-industry-pick", this.industrySelected);
      }
      this.temp_industrySelected = JSON.parse(
        JSON.stringify(this.industrySelected)
      );
      this.showPicker = false;
    },

    //获取基础数据选项
    PickerGetOptions() {
      httpGetIndustryJson({})
        .then(r => {
          if (r.success) {
            this.industryArray = r.data;
            this.industryArray.forEach(item => {
              this.$set(item, "checked", false);
            });
            //检查选中情况
            this.checkSelectedItem();
          } else {
            this.$notify({
              type: "warning",
              title: "警告",
              message: "获取职业数据失败"
            });
          }
        })
        .catch(error => {
          this.$notify({
            type: "warning",
            title: "警告",
            message: "获取数据失败"
          });
        });
    }
  }, //methods结束标记
  watch: {
    showError: function(newVal, oldVal) {
      if (oldVal !== newVal) {
        if (!this.showError) return;
        setTimeout(() => {
          this.showError = false;
        }, 1300);
      }
    }
  }
};
</script>

<style scoped lang="less">
.industry-picker {
  .base-input {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding-left: 12px;
    border: 1px solid #eee;
    background-color: #fff;
    border-radius: 2px;
    color: #333;
    &.error {
      border-color: #f56c6c;
    }
    &:hover {
      border-color: #c0c4cc;
    }
    &:focus {
      border-color: #409eff;
    }
  }
}

.picker-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 98;
  .picker {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 748px;
    height: 560px;
    background-color: #fff;
    z-index: 99;
  }
}

.picker-title {
  h3 {
    padding-left: 20px;
    line-height: 50px;
    color: #333;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    span {
      float: right;
      margin-right: 18px;
      font-size: 24px;
      font-weight: lighter;
      color: #999;
      &:hover {
        color: #666;
        cursor: pointer;
      }
    }
  }
}

.picker-selected {
  box-sizing: border-box;
  height: 64px;
  padding: 15px 20px;
}

.selected-list {
  li {
    float: left;
    margin-right: 10px;
    span {
      display: inline-block;
      margin-right: 6px;
    }
    .tips {
      color: #999;
      font-size: 14px;
      line-height: 30px;
      strong {
        font-weight: normal;
      }
    }
  }
}

.selected-item {
  position: relative;
  display: inline-block;
  padding: 0 29px 0 14px;
  line-height: 30px;
  color: #333;
  font-size: 14px;
  background-color: #f9f9f9;
  border-radius: 15px;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .icon-close {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: 14px;
    //width: 10px;
    font-size: 18px;
    color: #999;
    cursor: pointer;
    &:hover {
      color: #666;
    }
  }
}

.picker-body {
  box-sizing: border-box;
  padding: 0 20px;
  height: 392px;
  overflow: hidden;
}

.picker-tips {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 168px;
  height: 40px;
  z-index: 100;
  background-color: #fef0f0;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.4);
  p {
    text-align: center;
    color: #f56c6c;
    line-height: 40px;
  }
}

.options {
  position: relative;
  display: inline-block;
  float: left;
  width: 180px;
  margin-right: 72px;
  line-height: 40px;
  cursor: pointer;
  &:nth-child(3n) {
    margin-right: 0;
  }
  &::after {
    display: none; //暂时去掉装饰
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    height: 0;
    width: 0;
    right: 0;
    margin: auto 0;
    border-top: 5px solid transparent;
    border-left: 6px solid #ccc;
    border-bottom: 5px solid transparent;
  }
  input[name="picker-item"] {
    position: relative;
    float: left;
    width: 18px;
    height: 18px;
    margin: 11px 10px 0 0;
    opacity: 0;
    z-index: 3;
  }
  .fake-checker {
    position: absolute;
    top: 12px;
    left: 0;
    width: 16px;
    height: 16px;
    overflow: hidden;
    z-index: 2;
    .circle-hollow {
      display: block;
      width: 14px;
      height: 14px;
      border: 1px solid #d2d2d2;
      border-radius: 50%;
    }
    img {
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  .options-text {
    float: left;
    display: inline-block;
    max-width: 140px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #333;
  }
}

.picker-footer {
  position: absolute;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: center;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  height: 54px;
  border-top: 1px solid #eee;
  background-color: #fff;
  z-index: 9;
  .btn-operation {
    width: 86px;
    line-height: 32px;
    font-size: 16px;
    text-align: center;
    &.btn-cancel {
      color: #333;
      background-color: #eee;
    }
    &.btn-finish {
      color: #fff;
      background-color: #3b87ff;
      margin-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Common/IndustryPicker.vue